import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import ExposureCriteria from "./ExposureCriteria";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { ReportCategory } from "../ReportCategory";
import { Neo } from "@singularsystems/neo-react";
import { Data } from "@singularsystems/neo-core";
import Group from "../../../Domain/Models/Catalogue/Reporting/Group";
import BranchDetailLookup from "../../../Domain/Models/Catalogue/Reporting/Lookups/BranchDetailLookup";

@NeoReport("ExposureReport", { category: ReportCategory.IssuerReports })
export default class ExposureReport extends Report<ExposureCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache),
        private issuerApiClient = AppService.get(DomainTypes.ApiClients.Issuer),
        private reportingApiClient = AppService.get(DomainTypes.ApiClients.CatalogueReporting)) {
        super(ExposureCriteria);
        this.groupDataSource = new Data.ApiClientLookupDataSource(this.reportingApiClient.getGroups, Group);
        this.businessUnitDataSource = new Data.ApiClientLookupDataSource(this.reportingApiClient.getBusinessUnitDetailLookups, BranchDetailLookup);
    }

    public groupDataSource: Data.ApiClientLookupDataSource<Group>;
    public businessUnitDataSource: Data.ApiClientLookupDataSource<BranchDetailLookup>;

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.GridLayout md={1} lg={2}>
                <Neo.FormGroupInline bind={this.criteria.meta.entityId} select={{ itemSource: this.dataCache.entities }} />
                <Neo.FormGroupInline bindContext={this.criteria.meta.issuerId}>
                    <Neo.AutoCompleteDropDown
                        bind={this.criteria.meta.issuerId}
                        bindDisplay={this.criteria.meta.issuerName}
                        itemSource={this.issuerApiClient.getIssuerLookups}
                        onItemSelected={issuer => this.criteria.setIssuer(issuer)} />
                </Neo.FormGroupInline>
                <Neo.FormGroupInline bindContext={this.criteria.meta.groupId} label="Cluster" >
                    <Neo.AutoCompleteDropDown
                        bind={this.criteria.meta.groupId}
                        items={this.groupDataSource}
                        displayMember="groupName"
                        valueMember="groupId"
                        onItemSelected={group => this.criteria.setGroup(group)}
                        option={item => <>
                            <div>{item.groupCode}</div>
                            <div>{item.groupName}</div>
                        </>}
                    />
                </Neo.FormGroupInline>
                <Neo.FormGroupInline bindContext={this.criteria.meta.businessUnitId} label="Profit Centre" >
                    <Neo.AutoCompleteDropDown
                        bind={this.criteria.meta.businessUnitId}
                        items={this.businessUnitDataSource}
                        displayMember="profitCentre"
                        valueMember="businessUnitId"
                        onItemSelected={lookup => this.criteria.setProfitCentre(lookup)}
                        option={item => <>
                            <div>{item.profitCentreName}</div>
                            <div>{item.profitCentre}</div>
                        </>}
                    />
                </Neo.FormGroupInline>
            </Neo.GridLayout>
        </div>;
    }
}